import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinPesos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCoinPesos"><Path d="M7.5 10.5L16.5 10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 13.5H12.3471C14.0039 13.5 15.3471 12.1569 15.3471 10.5C15.3471 8.84315 14.0039 7.5 12.3471 7.5H9.5V13.5ZM9.5 13.5V16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCoinPesos;
